import { IRecord, IRecordType } from 'annotation-tools/utils';
import { ModelStatus } from '../enum/model-status';

// immutable object generator
export const IModel = IRecord<ModelType>({
  id: 0,
  companyId: 0,
  name: '',
  status: 'created',
  authorId: 0,
  adoptedVersionId: 0,
  numLabels: 0,
  numImages: 0,
  numUseInProjects: 0,
  canBeUsed: false,
  canBeDeleted: true,
  dateCreated: Date.now(),
  dateUpdated: Date.now()
});

// immutable type
export type IModelType = IRecordType<ModelType>;

type ModelType = {
  id: number;
  companyId: number;
  name: string; // [1..50] characters
  status: ModelStatus;
  authorId: number;
  adoptedVersionId: number;
  numLabels: number;
  numImages: number;
  numUseInProjects: number; // プロジェクトでの利用数
  canBeUsed: boolean;
  canBeDeleted: boolean;
  dateCreated: number;
  dateUpdated: number;
};
